var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"upload-button",attrs:{"title":_vm.title}},[_c('i',{staticClass:"fa fa-upload upload-icon"})])
}
var staticRenderFns = []

export { render, staticRenderFns }